import React from 'react';
import { IdCard, ClipboardCheck, TrendingUp, ArrowRight, ShieldCheck } from 'lucide-react';

const ITEMS = [
  { icon: IdCard, title: 'Carnet digital', text: 'Con código QR de verificación, descargable desde el celular.' },
  { icon: ClipboardCheck, title: 'Evaluaciones', text: 'Calificaciones y devoluciones docentes publicadas por la academia.' },
  { icon: TrendingUp, title: 'Progreso', text: 'Evolución en Listening, Speaking, Reading y Writing, objetivos y asistencia.' },
];

const EnglishIdPromo = () => (
  <section id="english-id" className="bg-[#1E3A5F] py-20 md:py-24 relative overflow-hidden" data-testid="landing-english-id-section">
    <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#8AA986]/15 pointer-events-none" />
    <div className="absolute -bottom-28 -left-20 h-64 w-64 rounded-full bg-[#B08D3C]/15 pointer-events-none" />
    <div className="mx-auto max-w-7xl px-6 lg:px-10 relative grid lg:grid-cols-[1.1fr_1fr] gap-12 items-center">
      <div>
        <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-widest text-[#E8B84A] px-3 py-1.5 border border-[#E8B84A]/40 rounded-full">
          <ShieldCheck className="h-3.5 w-3.5" />
          PLATAFORMA PARA ALUMNOS Y FAMILIAS
        </span>
        <h2 className="mt-5 font-serif text-4xl md:text-5xl leading-[1.05] font-bold text-[#FAF6EC]">
          English <span className="italic text-[#8AA986]">ID</span>
        </h2>
        <p className="mt-6 text-[15px] text-[#FAF6EC]/80 leading-relaxed max-w-lg">
          Cada alumno de Pinar English tiene su espacio personal para consultar su carnet, sus evaluaciones y su
          progreso. Las familias autorizadas pueden acompañar el aprendizaje con su propio acceso.
        </p>
        <a
          href="/english-id/login"
          className="mt-8 inline-flex items-center gap-2 bg-[#8AA986] hover:bg-[#9CB998] text-[#1E3A5F] text-[14px] font-semibold px-6 py-3 rounded-full transition-colors shadow-sm"
          data-testid="landing-english-id-cta"
        >
          Ingresar a English ID <ArrowRight className="h-4 w-4" />
        </a>
      </div>
      <div className="grid gap-4">
        {ITEMS.map(({ icon: Icon, title, text }) => (
          <div key={title} className="flex gap-4 items-start rounded-2xl bg-[#FAF6EC]/[0.06] border border-[#FAF6EC]/10 p-5">
            <span className="h-10 w-10 shrink-0 rounded-xl bg-[#FAF6EC] text-[#1E3A5F] flex items-center justify-center">
              <Icon className="h-5 w-5" />
            </span>
            <div>
              <h3 className="font-serif text-lg font-semibold text-[#FAF6EC]">{title}</h3>
              <p className="text-[13px] text-[#FAF6EC]/70 mt-1">{text}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default EnglishIdPromo;
